import { Select } from "antd";
import styled from "styled-components";

export const AntdSelect = styled(Select)`
  font-family: ${(props) => props.theme.fontText};

  &.selected {
    .ant-select-selector {
      background-color:  ${(props) => props.theme.softShadowGray} !important;
    }

    .ant-select-arrow {
      color:  ${(props) => props.theme.stepArrowColor};
    }
  }

  .ant-select-selection-wrap {
    height: 100%;

    .ant-select-selection-search-input {
      font-size: 18px;
    }
  }
`